var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "preview-inline",
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_vm._t("default"), _c('v-menu', {
    attrs: {
      "position-x": _vm.menuX,
      "position-y": _vm.menuY,
      "absolute": "",
      "offset-y": "",
      "close-on-content-click": false,
      "max-width": "800",
      "min-width": "700"
    },
    model: {
      value: _vm.showMenu,
      callback: function callback($$v) {
        _vm.showMenu = $$v;
      },
      expression: "showMenu"
    }
  }, [_c('v-card', {
    on: {
      "mouseenter": _vm.onMenuEnter,
      "mouseleave": _vm.onMenuLeave
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 pb-2"
  }, [_vm.loading ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "size": "20"
    }
  }), _c('div', {
    staticClass: "text-caption mt-1"
  }, [_vm._v(_vm._s(_vm.$translate('loading')))])], 1) : _vm.invoice && _vm.invoiceItems && _vm.invoiceItems.length > 0 ? _c('div', [_c('div', {
    staticClass: "pa-4 pb-0"
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center"
  }, [_c('div', [_c('router-link', {
    staticClass: "text-subtitle-2 font-weight-bold text-decoration-none",
    attrs: {
      "to": {
        name: 'customerinvoice',
        params: {
          invoice_id: _vm.invoice.id
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$utils.getInvoiceIdText(_vm.invoice)) + " ")])], 1), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "gap": "4px",
      "flex-wrap": "wrap",
      "justify-content": "flex-end"
    }
  }, [_vm.invoice.credit ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": "primary",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate('credit')) + " ")]) : _vm._e(), _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": _vm.$utils.getCustomerInvoiceStatusColor(_vm.invoice),
      "outlined": _vm.$utils.getCustomerInvoiceStatusOutlined(_vm.invoice)
    }
  }, [_vm._v(" " + _vm._s(_vm.$utils.getCustomerInvoiceStatusText(_vm.invoice)) + " ")]), _vm.invoice.sent && _vm.invoice.status === 'validated' ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": _vm.invoice.sent ? 'success' : 'grey',
      "outlined": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-email-check")]), _vm._v(" " + _vm._s(_vm.$translate('sent')) + " ")], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex justify-space-between mt-2 mb-2"
  }, [_c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm.invoice.biller_data ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-domain")]), _vm._v(" " + _vm._s(_vm.invoice.biller_data.name) + " ")], 1) : _vm._e(), _vm.invoice.billed_data ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-account")]), _vm._v(" " + _vm._s(_vm.invoice.billed_data.name) + " ")], 1) : _vm._e(), _vm.invoice.invoice_date ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-calendar")]), _vm._v(" " + _vm._s(_vm.$moment(_vm.invoice.invoice_date).format('ll')) + " ")], 1) : _vm._e(), _vm.invoice.due_date && !_vm.invoice.credit ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-calendar-clock")]), _vm._v(" " + _vm._s(_vm.$translate('due')) + ": " + _vm._s(_vm.$moment(_vm.invoice.due_date).format('ll')) + " ")], 1) : _vm._e()]), _c('div', {
    staticClass: "text-caption grey--text text-right"
  }, [_vm.invoice.total_amount_excl_vat !== null ? _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$utils.price(_vm.invoice.total_amount_excl_vat)) + " " + _vm._s(_vm.$translate('excl_vat')))]), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm.$utils.price(_vm.invoice.total_amount_incl_vat)) + " " + _vm._s(_vm.$translate('incl_vat')) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-receipt")]), _vm._v(" " + _vm._s(_vm.invoiceItems.length) + " " + _vm._s(_vm.$translate('lines')) + " ")], 1)])]), _c('v-divider', {
    staticClass: "mb-2"
  })], 1), _c('div', {
    staticClass: "invoice-items-list",
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto",
      "overflow-x": "auto"
    }
  }, [_c('v-simple-table', {
    staticClass: "no-wrap-table",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$translate('product')))]), _c('th', {
          staticClass: "text-right"
        }, [_vm._v(_vm._s(_vm.$translate('quantity')))])])]), _c('tbody', _vm._l(_vm.invoiceItems, function (item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', {
            staticClass: "text-left py-1"
          }, [_c('div', {
            staticClass: "font-weight-bold"
          }, [_vm._v(" " + _vm._s(_vm.getItemLabel(item)) + " "), item.manufacturer ? _c('i', {
            staticClass: "font-weight-bold grey--text"
          }, [_vm._v(" - " + _vm._s(item.manufacturer) + " ")]) : _vm._e()]), item.description ? _c('div', {
            staticClass: "text-caption grey--text"
          }, [_vm._v(" " + _vm._s(item.description) + " ")]) : _vm._e()]), _c('td', {
            staticClass: "text-right"
          }, [_c('v-chip', {
            attrs: {
              "x-small": "",
              "outlined": ""
            }
          }, [_vm._v(" " + _vm._s(_vm.$utils.formatSaleQuantityDisplay(item)) + " ")])], 1)]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1)]) : _vm.invoice ? _c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center mb-3"
  }, [_c('div', [_c('router-link', {
    staticClass: "text-subtitle-2 font-weight-bold text-decoration-none",
    attrs: {
      "to": {
        name: 'customerinvoice',
        params: {
          invoice_id: _vm.invoice.id
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$utils.getInvoiceIdText(_vm.invoice)) + " ")])], 1), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "gap": "4px",
      "flex-wrap": "wrap",
      "justify-content": "flex-end"
    }
  }, [_vm.invoice.credit ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": "primary",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate('credit')) + " ")]) : _vm._e(), _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": _vm.$utils.getCustomerInvoiceStatusColor(_vm.invoice),
      "outlined": _vm.$utils.getCustomerInvoiceStatusOutlined(_vm.invoice)
    }
  }, [_vm._v(" " + _vm._s(_vm.$utils.getCustomerInvoiceStatusText(_vm.invoice)) + " ")]), _vm.invoice.sent && _vm.invoice.status === 'validated' ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": _vm.invoice.sent ? 'success' : 'grey',
      "outlined": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-email-check")]), _vm._v(" " + _vm._s(_vm.$translate('sent')) + " ")], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm.invoice.biller_data ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-domain")]), _vm._v(" " + _vm._s(_vm.invoice.biller_data.name) + " ")], 1) : _vm._e(), _vm.invoice.billed_data ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-account")]), _vm._v(" " + _vm._s(_vm.invoice.billed_data.name) + " ")], 1) : _vm._e(), _vm.invoice.invoice_date ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-calendar")]), _vm._v(" " + _vm._s(_vm.$moment(_vm.invoice.invoice_date).format('ll')) + " ")], 1) : _vm._e(), _vm.invoice.due_date && !_vm.invoice.credit ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-calendar-clock")]), _vm._v(" " + _vm._s(_vm.$translate('due')) + ": " + _vm._s(_vm.$moment(_vm.invoice.due_date).format('ll')) + " ")], 1) : _vm._e(), _vm.invoice.total_amount_excl_vat !== null ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-currency-eur")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$utils.price(_vm.invoice.total_amount_excl_vat)) + " " + _vm._s(_vm.$translate('excl_vat')))]), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm.$utils.price(_vm.invoice.total_amount_incl_vat)) + " " + _vm._s(_vm.$translate('incl_vat')))])], 1) : _vm._e()])]) : _c('div', {
    staticClass: "text-body-2 pa-4 text-center grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate('no_invoice_found')) + " ")])])], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }